export const enum ChevronType {
  Leader = 'leader',
  Highlighted = 'highlighted',
  Inactive = 'inactive',
  Warning = 'warning',
  Apr = 'apr',
  Brown = 'brown',
  Discount = 'discount',
  PointerLarge = 'pointer-large',
  PointerSmall = 'pointer-small'
}

export const enum ElementType {
  Button = 'button'
}
